jQuery(document).ready(function($) {
  var $hamburger = $('.hamburger');
  var $drawerMenu = $('.b-drawer-menu');
  var $sidebarNav = $('.sidebar-nav');
  var headerHeight = Math.ceil($('header').outerHeight());

  $drawerMenu.css({
      'padding': headerHeight + 'px 0 0 0',
  });

  $hamburger.click(function() {
    $(this).toggleClass('open');
    $('.b-header').toggleClass('open');
    $('.b-header__menu-mobile').toggleClass('open');
    $drawerMenu.toggleClass('open');
    var expanded = $(this).attr('aria-expanded') === 'true' || false;
    $(this).attr('aria-expanded', !expanded);

    if ($drawerMenu.hasClass('open')) {
      $('body').css('overflow', 'hidden');
      $('body').css('height', '100vh');
    } else {
      $('body').css('overflow', '');
      $('body').css('height', '');
    }
  });

  $(window).resize(function() {
    if ($drawerMenu.hasClass('open')) {
      headerHeight = $('header').outerHeight();
      $drawerMenu.css({
          'top': headerHeight + 'px',
          'height': 'calc(100vh - ' + headerHeight + 'px)'
      });
    }
  });

  function slideToggleSubNav(menuToggle) {
    var isExpanded = $(menuToggle).attr('aria-expanded') === 'true';
    $(menuToggle).attr('aria-expanded', !isExpanded);    
    $(menuToggle).toggleClass('active');
    $(menuToggle).next('ul').slideToggle();
  }

  function showSubNav(menuToggle) {
    var isExpanded = $(menuToggle).attr('aria-expanded') === 'true';
    $(menuToggle).attr('aria-expanded', !isExpanded);    
    $(menuToggle).toggleClass('active');
    $(menuToggle).next('ul').toggleClass('active');
  }

  $('.menu-toggle', $('.b-header__menu__primary-menu')).on('click', function(){
    slideToggleSubNav(this);
  });

  $('.menu-toggle', $('.b-drawer-menu')).on('click', function(){
    slideToggleSubNav(this);
  });
  
  $('.menu-toggle', $('.b-header__top-bar')).on('click', function(){
    showSubNav(this);
  });

  $('.menu-toggle', $('.sidebar-nav')).on('click', function(){
    slideToggleSubNav(this);
    $($sidebarNav).toggleClass('open');
  });

  //quasi hover-intent for desktop navigation
  $('.nav-drop-item').each(function() {
    var $grandchild = $(this).find('ul.no-bullets');
    var timeoutId;

    $(this).on('mouseenter', function() {
      clearTimeout(timeoutId);
      $grandchild.addClass('show');
    }).on('mouseleave', function() {
      timeoutId = setTimeout(function() {
          $grandchild.removeClass('show');
      }, 1000);
    });

    $grandchild.on('mouseenter', function() {
        clearTimeout(timeoutId);
    }).on('mouseleave', function() {
      timeoutId = setTimeout(function() {
          $grandchild.removeClass('show');
      }, 1000);
    });
  });

  function getCurrentLanguage() {
    const lang = document.cookie
      .split('; ')
      .find(row => row.startsWith('prisna-wp-translate-prisna-translator-to='))
      ?.split('=')[1];
    return lang || 'en';
  }
  
  function updateVisibility() {
    const lang = getCurrentLanguage();
    if (lang === 'fr') {
      document.querySelectorAll('.hide-in-french').forEach(el => el.style.display = 'none');
    } else {
      document.querySelectorAll('.hide-in-french').forEach(el => el.style.display = '');
    }
  }
  
  // Initial run
  updateVisibility();
  
  setInterval(updateVisibility, 1000);
  
  //slider inits  
  let isSlickInitialized = false;

  function initializeCardSlick() {
    if (!isSlickInitialized) {
      $('.slider--card').slick({
        arrows: true,
        dots: true,
        infinite: false,
        speed: 400,
        slidesToShow: 3,
        slidesToScroll: 3,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: 1023,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 767,
            settings: "unslick"
          }
        ]
      });
      isSlickInitialized = true;
    }
  }
  
  function destroySlick() {
    if (isSlickInitialized) {
      $('.slider--card').slick('unslick');
      isSlickInitialized = false;
    }
  }
  
  function checkWindowSize() {
    if ($(window).width() < 767) {
      destroySlick();
    } else {
      initializeCardSlick();
    }
  }
  
  checkWindowSize();

  let resizeTimer;
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(checkWindowSize, 100);
  });

  // sliders
  sliderSliderBlockTestimonial();
  initializeCardSlick();
  sliderStatisticsSingleBlockInit();
  sliderStatisticsThreeBlockInit();

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=slider', acfRenderSliderBlockTestimonial );
    window.acf.addAction('render_block_preview/type=slider', acfRenderCardSliderBlock );
    window.acf.addAction('render_block_preview/type=two-column-content', acfRenderSliderBlockSingle );
    window.acf.addAction('render_block_preview/type=statistics-cards', acfRenderSliderBlockSingle );
    window.acf.addAction('render_block_preview/type=statistics-cards', acfRenderSliderBlockThree );
  }


  //slick slider testimonial block
  function acfRenderSliderBlockTestimonial(block) {
    var el = block.find('.slider--testimonial')[0];
    var sliders = block.find('.slider--testimonial');
    if(el){
      if (el.slick) return;
      if (window.acf) {
          if (sliders.hasClass('slick-initialized')) {
              sliders.slick('unslick');
          }
      }
      jQuery(el).slick({
          arrows: true,
          dots: true,
          infinite: true,
          cssEase: 'linear'
      });
    }
  }

  function sliderSliderBlockTestimonial() {
    jQuery('.slider--testimonial').slick({
      arrows: true,
      dots: true,
      speed: 600,
      cssEase: 'linear'
    });
  }

  //slick slider card block acf
  function acfRenderCardSliderBlock(block) {
    var el = block.find('.slider--card')[0];
    var sliders = block.find('.slider--card');
    if(el){
      if (el.slick) return;
      if (window.acf) {
          if (sliders.hasClass('slick-initialized')) {
              sliders.slick('unslick');
          }
      }
      jQuery(el).slick({
        arrows: true,
        dots: true,
        infinite: false,
        speed: 400,
        slidesToShow: 3,
        slidesToScroll: 3,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: 1023,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 767,
            settings: "unslick"
          }
        ]
      });
    }
  }

  //slick slider statistics block
  function acfRenderSliderBlockSingle(block) {
    var el = block.find('.slider-statistics--single')[0];
    var sliders = block.find('.slider-statistics--single');
    if(el){
      if (el.slick) return;
      if (window.acf) {
          console.log(true);
          if (sliders.hasClass('slick-initialized')) {
              sliders.slick('unslick');
          }
      }
      jQuery(el).slick({
        arrows: false,
        dots: true,
        infinite: true,
        speed: 400,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
      });
    }
  }

  function sliderStatisticsSingleBlockInit() {
    jQuery('.slider-statistics--single').slick({
      arrows: false,
      dots: true,
      speed: 400,
      cssEase: 'linear'
    });
  }

  function acfRenderSliderBlockThree(block) {
    var el = block.find('.slider-statistics--three')[0];
    var sliders = block.find('.slider-statistics--three');
    if(el){
      if (el.slick) return;
      if (window.acf) {
          if (sliders.hasClass('slick-initialized')) {
              sliders.slick('unslick');
          }
      }
      jQuery(el).slick({
          arrows: false,
          dots: true,
          infinite: true,
          speed: 400,
          cssEase: 'linear'
      });
    }
  }

  function sliderStatisticsThreeBlockInit() {
    jQuery('.slider-statistics--three').slick({
      arrows: false,
      dots: true,
      infinite: false,
      speed: 400,
      slidesToShow: 3,
      slidesToScroll: 3,
      cssEase: 'linear',
      responsive: [
        {
          
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    });
  }
  
  //translated buttons
  if($('.btn--special').length > 0){
    $('.btn--special').each(function(){
      const width = Math.max($(this).find('.btn__text--english').outerWidth(), $(this).find('.btn__text--french').outerWidth());
      const height = Math.max($(this).find('.btn__text--english').outerHeight(), $(this).find('.btn__text--french').outerHeight());
      $(this).find('.btn__spacer').css({'width': width, 'height': height});      
    })
  }

  //basic accordion
  $('.b-accordion__trigger').click(function() {
    var content = $(this).next('.b-accordion__content');
    $(this).attr('aria-expanded', !$(this).attr('aria-expanded'));

    // Use slideToggle to animate the accordion
    content.slideToggle(300); // Adjust duration as needed

    // Optionally, you can toggle a class on the button to change its appearance
    $(this).toggleClass('active');
  });
  

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=accordion-item', (block) => {
      block.find('.b-accordion__trigger').click(function() {
        var content = $(this).next('.b-accordion__content');
        $(this).attr('aria-expanded', !$(this).attr('aria-expanded'));
    
        // Use slideToggle to animate the accordion
        content.slideToggle(300); // Adjust duration as needed
    
        // Optionally, you can toggle a class on the button to change its appearance
        $(this).toggleClass('active');
      });
    });
  }

  //horizontal and accordion-with-image trigger
  function openFirstPanel() {
    $('.block-horizontal-accordion').each(function () {
      var parent = $(this);
      parent.find('.b-horizontal-accordion li:first').addClass('active');

      if ($(window).width() < 1024) {
        parent.find('.b-horizontal-accordion li:first .content').slideDown();
      }
      if ($(window).width() > 1023) {
        parent.find('.image-container li:first').addClass('active');
      }
    });

    $('.block-accordion-with-image').each(function () {
      var parent = $(this);
      parent.find('.b-accordion-with-image li:first').addClass('active');
      parent.find('.b-accordion-with-image li:first .content').slideDown();

      if ($(window).width() > 1023) {
        parent.find('.image-container li:first').addClass('active');
      }
    });
  }

  function horizontalAccordion() {
    $('.b-horizontal-accordion .trigger').off('click').on('click', function () {
        var parentLi = $(this).parent('li');
        var parentUl = parentLi.parent('ul');

        // Check if already active
        var isActive = parentLi.hasClass('active');

        // Remove active class and close all except the one being clicked
        parentUl.find('li.active').removeClass('active').find('.content').slideUp();

        if (!isActive) {
            parentLi.addClass('active');
            $(this).next('.content').slideDown();
        }
    });
  }

  openFirstPanel();
  horizontalAccordion();

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=horizontal-accordion', openFirstPanel );
    window.acf.addAction('render_block_preview/type=horizontal-accordion', horizontalAccordion );
  }


  function accordionWithImage() {
    $('.b-accordion-with-image .trigger').click(function() {
      var parentLi = $(this).parent('li');
      var parentUl = parentLi.parent('ul');
      parentLi.toggleClass('active');
      $(this).next('.content').slideDown();
      parentUl.find('li').not(parentLi).removeClass('active').find('.content').slideUp();
    });

    if ($(window).width() > 1023) {
      $('.block-accordion-with-image').each(function(){
        var parent = $(this);
        $(this).find('.b-accordion-with-image li[class^="tab--"]').on('click', function() {
          var classNumber = $(this).attr('class').match(/tab--(\d+)/)[1];
          var targetId = $(this).attr('data-image');
          parent.find('.image-container li').removeClass('active');
          $(this).addClass('active');
          $('#' + targetId).addClass('active');
        });
  
        $(this).find('li[class^="tab--"]').on('click', function() {
            $(this).trigger('classChange');
        });
      })
    }
  }

  accordionWithImage();
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=accordion-with-image', accordionWithImage );
  }

  $(window).resize(function() {
    horizontalAccordion();
    accordionWithImage();
  });

  if (window.acf) {

    window.acf.addAction('render_block_preview/type=locations', () => {
      $('.location__marker').click(function() {
        console.log('map-click');
        var parent = $(this).parents('.block-locations');
        var content = $(this).attr('aria-controls');
        parent.find('.location__card.active').attr('aria-hidden', 'true');
        parent.find('.location__marker.active').attr('aria-selected', 'false');
        parent.find('.active').removeClass('active');
        $(this).attr('aria-selected', 'true');
        $(this).addClass('active');
        $('#' + content).attr('aria-hidden', 'false');
        $('#' + content).addClass('active');
      });
    } );
  }

  
  $('.location__marker').click(function() {
    console.log('map-click');
    var parent = $(this).parents('.block-locations');
    var content = $(this).attr('aria-controls');
    parent.find('.location__card.active').attr('aria-hidden', 'true');
    parent.find('.location__marker.active').attr('aria-selected', 'false');
    parent.find('.active').removeClass('active');
    $(this).attr('aria-selected', 'true');
    $(this).addClass('active');
    $('#' + content).attr('aria-hidden', 'false');
    $('#' + content).addClass('active');
  });

  //basic modal
  const openModalButtons = document.querySelectorAll('.btn-search'),
  modal = document.querySelector('.modal'),
  modalBody = document.querySelector('body'),
  closeModalButtons = document.querySelectorAll('.modal-close-button');

  function toggleModal() {
    modal.classList.toggle("show-modal");
    modalBody.classList.toggle("modal-open");
    document.getElementById('s').focus();
  }

  function windowOnClick(event) {
    if (event.target === modal) {
        toggleModal();
    }
  }

  openModalButtons.forEach(openBtn => {
    openBtn.addEventListener('click', toggleModal)
  });

  closeModalButtons.forEach(closeBtn => {
    closeBtn.addEventListener('click', toggleModal)
  });

  window.addEventListener("click", windowOnClick);

  // Notification Bar
  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }

  function getCookie(name) {
    const cname = name + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i].trim();
      if (cookie.indexOf(cname) === 0) {
        return cookie.substring(cname.length, cookie.length);
      }
    }
    return "";
  }

  if (getCookie('notificationClosed') !== 'true' && $('.notification-bar').length > 0) {
    $('.notification-bar').show();
  } else {
    $('.notification-bar').hide();
  }

  $('.notification-bar__close').on('click', function(){
    $(this).closest('.notification-bar').remove();
    setCookie('notificationClosed', 'true', 14);
  });
  
  $('.b-basic-card').on('click', function(){
    $(this).toggleClass('active');
  })
});

//english/french text fades
function fadeAndAdjustHeightWithinHeading(heading) {
  const englishText = heading.querySelector('.heading__text--english');
  const frenchText = heading.querySelector('.heading__text--french');

  if (englishText.classList.contains('visible')) {
    // Hide English, show French
    englishText.classList.remove('visible');
    englishText.style.display = 'none';

    frenchText.style.display = 'block';
    frenchText.classList.add('visible');

    // Adjust container height
    heading.style.height = `${frenchText.offsetHeight}px`;
  } else {
    // Hide French, show English
    frenchText.classList.remove('visible');
    frenchText.style.display = 'none';

    englishText.style.display = 'block';
    englishText.classList.add('visible');

    // Adjust container height
    heading.style.height = `${englishText.offsetHeight}px`;
  }
}

// Start automatic fade with mutual exclusivity for the visible class
function startAutomaticFade(heading) {
  const interval = setInterval(() => {
    fadeAndAdjustHeightWithinHeading(heading);
  }, 5000);

  heading.dataset.intervalId = interval;

  // Set the initial text and height
  const englishText = heading.querySelector('.heading__text--english');
  const frenchText = heading.querySelector('.heading__text--french');

  englishText.classList.add('visible');
  englishText.style.display = 'block';
  frenchText.classList.remove('visible');
  frenchText.style.display = 'none';
  heading.style.height = `${englishText.offsetHeight}px`;
}

// Stop the fade animation
function stopAutomaticFade(heading) {
  const intervalId = heading.dataset.intervalId;
  if (intervalId) {
    clearInterval(intervalId);
    delete heading.dataset.intervalId;
  }
}

// Intersection Observer to pause/start fade when in/out of viewport
const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      startAutomaticFade(entry.target);
    } else {
      stopAutomaticFade(entry.target);
    }
  });
});

document.querySelectorAll('.heading').forEach((heading) => {
  observer.observe(heading);
});

// Set parent height for proper layout
function setParentHeight() {
  document.querySelectorAll('.block-hero .acf-innerblocks-container').forEach((parentDiv) => {
    const child1 = parentDiv.querySelector('.heading__text--english');
    const child2 = parentDiv.querySelector('.heading__text--french');
    const wp_block_heading = parentDiv.querySelector('.wp-block-heading');
    const additionalContent = parentDiv.querySelector('.additional-content');

    const child1Height = child1 ? child1.offsetHeight : 0;
    const child2Height = child2 ? child2.offsetHeight : 0;
    const wp_block_headingHeight = wp_block_heading ? wp_block_heading.offsetHeight : 0;
    const additionalHeight = additionalContent ? additionalContent.offsetHeight : 0;

    const tallestHeight = Math.max(child1Height, child2Height, wp_block_headingHeight);
    parentDiv.style.height = `${tallestHeight + additionalHeight + 50}px`;
  });
}

// Initial height setup and responsiveness
document.addEventListener('DOMContentLoaded', setParentHeight);
window.addEventListener('resize', setParentHeight);
